import React from 'react';

import { style } from 'utils/constants/style';
import { AppleIcon } from 'public/assets/icons';
import { RectangleButton } from '../index';
import { IAppleButton } from './IAppleButton';

const AppleButton = ({ text, onClick }: IAppleButton) => (
  <RectangleButton
    text={text}
    onClick={onClick}
    color="#ffffff"
    backgroundColor={style.mainBlack.appleBtnBlack}
    height="46px"
    icon={<AppleIcon />}
    fontSize={15}
  />
);

export default AppleButton;
